import Rebase from 're-base';
import firebase from 'firebase';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDqefRw3ds7EpwtRbv9509O5ZHByi8OCSE",
    authDomain: "fish-shop-f53f8.firebaseapp.com",
    databaseURL: "https://fish-shop-f53f8.firebaseio.com"
  });

  const base = Rebase.createClass(firebaseApp.database());

  export { firebaseApp };

  export default base;



// WEBPACK FOOTER //
// ./src/base.js